import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import Navigation from './navigation';
import Landing from './landing';
import Report from './report';
import Glossary from '../shared/glossary';
import Tooltip from '../shared/tooltip';
import PrintIcon from '../shared/print-icon';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import _ from 'underscore';
import { accScroll } from '../../../page-accordion';

dayjs.extend(customParseFormat);

class Component extends BaseComponent {
    constructor() {
        super();
        this.mainnavs = [
            {
                text: 'Summary',
                slug: 'summary',
            },
            {
                text: 'Your Report',
                slug: 'your-report',
            },
            {
                text: 'Glossary',
                slug: 'glossary',
            },
        ];

        this.prev_link = null;
        this.next_link = null;

        this.tooltipContent = 'Some of the planets and placements in your Astrology chart move so quickly that they could have changed once or even many times throughout your day of birth. This is why your time of birth is an important factor in calculating your chart. In order to get the most complete and personalized information from your reading, you can update your birth time at any time here.'; //eslint-disable-line max-len
    }

    componentDidMount() {
        if (!this.props.report.product.inputs.person_1_birth_time) {
            this.props.trackEvent([
                'Site Interaction',
                `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
                'Time-Unknown-Link-Header',
            ]);
            this.props.trackEvent([
                'Site Interaction',
                `${this.props.logged_in ? 'LI' : 'LO'} Impression`,
                'Time-Unknown-Link-Landing',
            ]);
        }

        if (window.matchMedia) {
            const mQL = window.matchMedia('print');
            const that = this;

            mQL.addListener((mql) => {
                if (mql.matches) {
                    that.trackPrint();
                }
            });
        } else {
            window.addEventListener('afterprint', this.trackPrint);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.report != this.props.report) {
            return true;
        }

        if (nextProps.route != this.props.route) {
            return true;
        }

        if (nextProps.logged_in != this.props.logged_in) {
            return true;
        }

        return false;
    }

    componentWillUnmount() {
        if (!window.matchMedia) {
            window.removeEventListener('afterprint', this.trackPrint);
        }
    }

    render() {
        return (
            <astrology-compatibility-report>
                {this.renderHeader()}
                <Navigation mainnavs={this.mainnavs} />
                <Landing
                    renderBirthDate={this.renderBirthDate}
                    renderBirthTime={this.renderBirthTime}
                    renderBirthLocation={this.renderBirthLocation}
                />
                <Report />
                <Glossary selector='astrology-compatibility-report' />
                {this.renderFooter()}
                {this.renderPrintFooter()}
            </astrology-compatibility-report>
        );
    }

    /* eslint-disable max-len */
    renderHeader = () => {
        if (this.props.route && (this.props.route.match(/^your-report/) || this.props.route.match(/^glossary/))) {
            return (
                <div className='has-text-center ascom-header'>
                    <p className='has-text-oslo-grey is-hidden-print'>{dayjs(this.props.report.product.created).format('MMMM D, YYYY')}</p>
                    <h1 className='fancy-title'>{this.props.report.product.display.name}</h1>
                    <row className='is-wrap is-justified-center has-margin-20-bottom'>
                        <column className='has-text-left has-padding-20-right-desktop has-padding-20-right-tablet has-padding-20-bottom-mobile has-text-center-mobile is-12-mobile'>
                            <p className='has-margin-0'>{this.props.report.product.inputs.person_1_name.first}</p>
                            <p className='has-margin-0'>{this.renderBirthDate(this.props.report.product.inputs.person_1_birth_date)}{this.renderBirthTime(this.props.report.product.inputs.person_1_birth_time, 'Header', 1)}</p>
                            <p className='has-margin-0'>{this.renderBirthLocation(this.props.report.product.inputs.person_1_birth_location)}</p>
                        </column>
                        <column className='has-text-left has-padding-20-left-desktop has-padding-20-left-tablet has-text-center-mobile is-12-mobile'>
                            <p className='has-margin-0'>{this.props.report.product.inputs.person_2_name.first}</p>
                            <p className='has-margin-0'>{this.renderBirthDate(this.props.report.product.inputs.person_2_birth_date)}{this.renderBirthTime(this.props.report.product.inputs.person_2_birth_time, 'Header', 2)}</p>
                            <p className='has-margin-0'>{this.renderBirthLocation(this.props.report.product.inputs.person_2_birth_location)}</p>
                        </column>
                    </row>
                </div>
            );
        }

        return null;
    }
    /* eslint-enable max-len */

    renderBirthDate = (birth_date) => {
        return dayjs(birth_date, 'YYYY-MM-DD').format('MMMM D, YYYY');
    }

    renderBirthTime = (birth_time, location, person) => {
        if (birth_time) {
            return ` ${dayjs(birth_time, 'HH:mm:ss').format('h:mm A')}`;
        }

        const content = this.tooltipContent.replace(/here\./, `<a href="#summary-person-${person}">here</a>.`);

        if (location == 'Header') {
            return [
                <br />,
                <Tooltip
                    location={location}
                    content={content}
                    text='Time Unknown'
                />,
            ];
        }

        return (
            <Tooltip
                location={location}
                content={content}
                text='Time Unknown'
            />
        );
    }

    renderBirthLocation = (birth_location) => {
        let location = `${birth_location.city}`;

        if (birth_location.state) {
            location = `${location}, ${birth_location.state}`;
        }

        if (birth_location.country != 'United States') {
            location = `${location}, ${birth_location.country}`;
        }

        return location;
    }

    renderFooter = () => {
        if (!this.props.route || (!this.props.route.match(/^your-report/) && !this.props.route.match(/^glossary/))) {
            this.prev_link = {
                href: 'glossary',
                text: 'Glossary',
            };

            this.next_link = {
                href: 'your-report',
                text: 'Your Report',
            };
        } else if (this.props.route.match(/^your-report/)) {
            if (this.props.is_sample) {
                this.prev_link = {
                    href: 'summary',
                    text: 'Summary',
                };

                this.next_link = {
                    href: 'glossary',
                    text: 'Glossary',
                };
            } else {
                this.getReportLinks();
            }
        } else if (this.props.route.match(/^glossary/)) {
            this.prev_link = {
                href: 'your-report',
                text: 'Your Report',
            };

            this.next_link = {
                href: 'summary',
                text: 'Summary',
            };
        }

        if (this.prev_link && this.next_link) {
            return (
                <section className='ascom-footer is-hidden-print'>
                    <row className='is-aligned-center'>
                        <column className='is-4 is-5-mobile has-padding-5-left-mobile'>
                            <a
                                href={`#${this.prev_link.href}`}
                                className='has-text-boulder'
                                onClick={this.goTo}
                            >
                                <span className='left-arrow'>&#9656;</span> {this.prev_link.text}
                            </a>
                        </column>
                        <column className='is-4 is-2-mobile has-text-center'>
                            <PrintIcon selector='astrology-compatibility-report' />
                        </column>
                        <column className='is-4 is-5-mobile has-text-right has-padding-5-right-mobile'>
                            <a
                                href={`#${this.next_link.href}`}
                                className='has-text-boulder'
                                onClick={this.goTo}
                            >
                                {this.next_link.text} <span>&#9656;</span>
                            </a>
                        </column>
                    </row>
                </section>
            );
        }

        return (
            <row className='is-aligned-center is-hidden-print ascom-footer'>
                <column className='is-12 has-text-center'>
                    <PrintIcon />
                </column>
            </row>
        );
    }

    getReportLinks = () => {
        let your_report_links = [];

        this.props.report.product.navigator.map(section => {
            if (section.prefix && section.prefix != '0:' && section.code != 'glossary') {
                if (!this.props.is_full) {
                    if (
                        this.props.report.product_code == 'relationship-potential-redux'
                        &&
                        !_.contains(['relationship_dynamics', 'love_languages', 'today_and_beyond'], section.code)
                    ) {
                        your_report_links.push({
                            text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                            href: `your-report-${section.code.replace(/_/g, '-')}`,
                        });
                    } else if (
                        this.props.report.product_code == 'relationship-dynamics-redux'
                        &&
                        !_.contains(['love_languages', 'relationship_potential', 'today_and_beyond'], section.code)
                    ) {
                        your_report_links.push({
                            text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                            href: `your-report-${section.code.replace(/_/g, '-')}`,
                        });
                    } else if (
                        this.props.report.product_code == 'love-languages-redux'
                        &&
                        !_.contains([
                            'relationship_dynamics',
                            'relationship_potential',
                            'today_and_beyond',
                        ], section.code)
                    ) {
                        your_report_links.push({
                            text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                            href: `your-report-${section.code.replace(/_/g, '-')}`,
                        });
                    }
                } else {
                    your_report_links.push({
                        text: `${section.prefix.replace(/:/, '.')} ${section.long_name}`,
                        href: `your-report-${section.code.replace(/_/g, '-')}`,
                    });
                }
            }
        });

        if (this.props.route == 'your-report' || this.props.route.match(your_report_links[0].href)) {
            this.prev_link = {
                text: 'Summary',
                href: 'summary',
            };

            this.next_link = {
                text: your_report_links[1].text,
                href: your_report_links[1].href,
            };
        } else {
            your_report_links.forEach((yr, i) => {
                if (this.props.route.match(yr.href)) {
                    this.prev_link = {
                        text: your_report_links[i - 1].text,
                        href: your_report_links[i - 1].href,
                    };

                    if (this.props.route.match(yr.href) && i != your_report_links.length - 1) {
                        this.next_link = {
                            text: your_report_links[i + 1].text,
                            href: your_report_links[i + 1].href,
                        };
                    } else {
                        this.next_link = {
                            text: 'Glossary',
                            href: 'glossary',
                        };
                    }
                }
            });
        }
    }

    renderPrintFooter = () => {
        return (
            <section className='ascom-print-footer is-visible-print'>
                <row className='is-aligned-center'>
                    <column className='is-4 has-padding-15-left'>
                        {this.props.report.product.display.name}
                    </column>
                    <column className='is-4 has-text-center'>
                        <img src='https://gfx.tarot.com/images/site/logo/logo.svg' alt='Tarot.com' />
                    </column>
                    <column className='is-4 has-text-right has-padding-15-right'>
                        © Zappallas USA {dayjs().year()}
                    </column>
                </row>
            </section>
        );
    }

    trackPrint = () => {
        this.props.trackEvent([
            'Site Interaction',
            `${this.props.logged_in ? 'LI' : 'LO'} Print`,
            this.props.report.product_code,
        ]);
    }

    goTo = (e) => {
        if (e.target && e.target.hash) {
            accScroll(e.target.hash.replace('#', ''), 300);
        }
    }
}

const mapStateToProps = (state) => ({
    report: state.report,
    route: state.route,
    logged_in: state.user && state.user.logged_in,
    is_sample: state.report && state.report.product_code
        && state.report.product_code == 'astrology-compatibility-sample',
    is_full: state.report && state.report.product_code
        && state.report.product_code == 'astrology-compatibility-redux',
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
